/**
 * author       : zwl
 * createTime   : 2018/6/28 下午5:08
 * description  :
 */
import api from 'util/axios'

export function getDriverForPhone (phone, pageSize, current) {
  return api({
    method: 'get',
    url: '/driver/' + phone,
    params: {pageSize: pageSize, current: current}
  })
}

export function selectDriver (phone) {
  return api({
    method: 'get',
    url: '/driver/find/' + phone
  })
}

export function updateDriver (driverId, driverParam) {
  return api({
    method: 'put',
    url: '/driver/' + driverId,
    data: driverParam
  })
}

export function driverListByApp (params) {
  return api({
    method: 'post',
    url: '/driver/driverListByApp/' + params.appId,
    data: params
  })
}
